import { Tooltip } from "../../Tooltip/index.js";
import { ListItem } from "./ListItem.js";
import { IconArrowDown } from "@synthesis/shared-icons";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/Select/local-components/ListItemGroup.tsx
const ListItemGroup = ({ group, search, className, isOpen, onToggleOpen: handleToggleOpen }) => /* @__PURE__ */ jsxs("div", {
	className,
	children: [/* @__PURE__ */ jsx(Tooltip, {
		description: group.label,
		children: /* @__PURE__ */ jsx("button", {
			type: "button",
			className: "text-type-light max-w-full cursor-pointer border-none bg-transparent pl-2.5 pt-1 text-sm outline-none",
			onClick: handleToggleOpen,
			children: /* @__PURE__ */ jsxs("span", {
				className: "flex max-w-full flex-nowrap items-center truncate",
				children: [/* @__PURE__ */ jsx("span", {
					className: "truncate",
					children: group.label
				}), /* @__PURE__ */ jsx(IconArrowDown, {
					className: "size-5 min-w-5 transition-all data-[open='true']:rotate-180",
					"data-open": isOpen
				})]
			})
		})
	}), /* @__PURE__ */ jsx("ul", {
		className: "data-[open='false']:hidden",
		"data-open": isOpen,
		children: group.items.map((item, index) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(ListItem, {
			...item,
			search
		}) }, index))
	})]
});
//#endregion
export { ListItemGroup };

//# sourceMappingURL=ListItemGroup.js.map